import { CheckOutlined, CloseOutlined, EditFilled } from '@ant-design/icons';
import Flag from 'react-flagpack';

import { Button, ErrorBoundary } from '../../../../components/index';
import { pilotFunctionList } from '../../../../utils/lists';

export function columns(onSelectItem: (item: any) => void) {
  return [
    {
      title: <div className="show-amount">Cod. ANTAQ</div>,
      key: 'antaq_code',
      dataIndex: 'antaq_code',
    },
    {
      title: 'Nome ANTAQ',
      key: 'antaq_name',
      dataIndex: 'antaq_name',
    },
    {
      title: 'Código Mercante',
      key: 'merchant_code',
      dataIndex: 'merchant_code',
    },
    {
      title: 'Nome Mercante',
      key: 'merchant_name',
      dataIndex: 'merchant_name',
    },
    {
      title: 'Ativo',
      key: 'archived_at',
      dataIndex: 'archived_at',
      render: (value: any, record: any) => {
        return value ? <CloseOutlined /> : <CheckOutlined />;
      },
    },
    {
      title: 'Porto',
      key: 'port_name',
      dataIndex: 'port_name',
    },
    {
      render: (_: any, record: any) => (
        <Button
          icon={<EditFilled />}
          style={{ float: 'right' }}
          onClick={() => onSelectItem(record)}
        />
      ),
    },
  ];
}
